import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsEN from './locales/en/translations.json';
import translationsIT from './locales/it/translations.json';

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    defaultNS: 'translations',
    resources: {
      'en': { 
        translations: translationsEN
      },
      'it': {
        translations: translationsIT
      }
    },
  });

export default i18n;